import { GridSortModel } from '@mui/x-data-grid';

const FIELD_TO_ENTITY_MAPPING: Record<string, string> = {
    id: 'id',
    advertiser: 'dealer.dealerName',
    dspAdvertiserID: 'dealer.dspAdvertiser',
    platform: 'platform',
    oemProgram: 'oemProgram',
    poNumber: 'poNumber',
    dspCampaignID: 'dspCampaignId',
    campaignName: 'campaignName',
    budget: 'budget',
    dspCampaignSyncedDate: 'dspCampaignSyncedDate',
    startDate: 'startDate',
    endDate: 'endDate',
    deliveryStatusId: 'deliveryStatusId',
    activationStatusId: 'activationStatusId',
    mediaType: 'mediaType',
    campaignType: 'campaignType',
    strategyType: 'strategyType',
    audienceType: 'audienceType',
    bidStrategy: 'bidStrategy',
    goal: 'goal',
    budgetCapTye: 'budgetCapType',
    kpi: 'kpi',
    frequencyType: 'frequencyType',
    frequencyTimeUnitCount: 'frequencyTimeUnitCount',
    frequencyTimeUnit: 'frequencyTimeUnit',
    frequencyMaxImpressions: 'frequencyMaxImpressions',
    budgetCapAmount: 'budgetCapAmount',
    budgetCapRecurrenceTimePeriod: 'budgetCapRecurrenceTimePeriod',
};

const ALLOWED_BACKEND_PROPERTIES = new Set([
    'id',
    'dealer.dealerName',
    'dealer.dspAdvertiser',
    'platform',
    'oemProgram',
    'poNumber',
    'dspCampaignId',
    'campaignName',
    'budget',
    'dspCampaignSyncedDate',
    'startDate',
    'endDate',
    'deliveryStatusId',
    'activationStatusId',
    'mediaType',
    'campaignType',
    'strategyType',
    'audienceType',
    'bidStrategy',
    'goal',
    'budgetCapType',
    'kpi',
    'frequencyType',
    'frequencyTimeUnitCount',
    'frequencyTimeUnit',
    'frequencyMaxImpressions',
    'budgetCapAmount',
    'budgetCapRecurrenceTimePeriod',
]);

/**
 * Transform DataGrid sortModel to backend-compatible sortModel
 * Maps field names like 'dspAdvertiserID' to 'dealer.dspAdvertiser'
 */
export function transformSortModelForBackend(sortModel: GridSortModel): GridSortModel {
    if (!sortModel || sortModel.length === 0) {
        return sortModel;
    }

    return sortModel
        .map((sortItem) => {
            const frontendField = sortItem.field;
            const backendProperty = FIELD_TO_ENTITY_MAPPING[frontendField] || frontendField;

            if (!ALLOWED_BACKEND_PROPERTIES.has(backendProperty)) {
                console.warn(`Blocked unauthorized sort property: ${backendProperty} (from field: ${frontendField})`);
                return null;
            }

            return {
                ...sortItem,
                field: backendProperty,
            };
        })
        .filter((item) => item !== null) as GridSortModel;
}
